const p1 = `대한민국도시포럼에 관심을 갖고 지켜봐 주시는 여러분 감사합니다.`;

const p2 = `유엔해비타트 한국위원회와 서울신문은 <2022 제3회 대한민국도시포럼 - 지속가능한 미래를 위한 도시의 전환>을 오는 10월 19일(수)~20일(목), 한국프레스센터에서 개최합니다.`;

const p3 = `대한민국도시포럼(KUF)은 UN의 세계도시포럼(WUF)의 정신을 계승한 한국형 포럼으로서, 다양한 분야의 전문가들의 참여를 바탕으로 협력과 상생의 ‘더 나은 도시의 미래’를 함께 실현하는 기회와 도구를 제공하는 열린 플랫폼입니다.`;

const p4 = `디지털 전환이라는 시대적 변화와 기후변화, 코로나, 저성장과 같은 새로운 위기가 대두되고 있습니다. 도시를 구성하는 모든 부문을 조화롭게 고려한 종합적인 도시의 체질 개선이 필요합니다. 이에 제3회 대한민국도시포럼은 ‘모두를 위한, 모두에 의한’ 지속가능한 미래를 실현하는 도시의 전환 전략을 다룹니다.`;

const p5 = `제3회 대한민국도시포럼 참여를 통해 더 나은 도시의 미래, 인간 중심의 지속가능한 도시를 만드는 새로운 지식과 정보를 먼저 경험하는 유익한 시간을 보내시길 바랍니다.`;

const signiture1 = `유엔해비타트 한국위원회 회장 최기록`;

const signiture2 = `서울신문 대표이사 곽태헌`;

const signiture0 = `대한민국 도시포럼 조직위원장 나성린`;

export const paragraphs = [p1, p2, p3, p4, p5];
export const signitures = [signiture0, signiture1, signiture2];
